// extracted by mini-css-extract-plugin
module.exports = {"pointerTarget":"PointerDot_pointerTarget__M5I76","pointerDot":"PointerDot_pointerDot__UbAMc"};